import LegalPage from "./LegalPage";

export default function PrivacyPolicy() {
  return (
    <LegalPage
      title="Privacy Policy"
      subtitle="Your privacy and data security are important to us."
      sections={[
        {
          heading: "Information We Collect",
          text: "We may collect your name, email, phone number, uploaded product images, payment details, and optimization history.",
        },
        {
          heading: "How We Use Your Data",
          text: "We use your data to provide image optimization, manage credits, process payments, and improve our service.",
        },
        {
          heading: "Image Privacy",
          text: "Your uploaded images are used only for optimization. We do not sell or share your images with third parties.",
        },
        {
          heading: "Payments",
          text: "Payments are processed through secure payment gateways. We do not store your card or banking details.",
        },
        {
          heading: "Contact",
          text: "For privacy related questions, contact us at support@shipless.in.",
        },
      ]}
    />
  );
}